import type { ApiV1 } from '@teamworksdev/influencer/core';
import { getList, isApiError } from './utilities/provider';
import type { AxiosRequestConfig } from 'axios';

const RESOURCE = 'schools';

export function useSchoolsService(config?: Omit<AxiosRequestConfig, 'key'>) {
	const getSchools = async (params?: ApiV1.GetSchoolsRequestParams) => {
		const response = await getList<ApiV1.GetSchoolsResponse>(RESOURCE, {
			key: 'getSchools',
			params,
			...config,
		});
		if (isApiError(response)) throw response;
		return response.data.data;
	};

	return {
		getSchools,
	};
}
